import ChatFilesContainer from './ChatFilesContainer';

export default ChatFilesContainer;
